<template lang="pug">
  v-container(fluid class="pt-0")
    Title(titleName="Строительные компании", class="mb-5")
    v-row
      v-col(cols="3", v-for="company in companyList", :key="company.companyId")
        v-card(outlined class="company-card" @click="viewCompanyPage(company.companyId)")
          v-img(:src="!company.photos[0] ? require('@/assets/images/noimage.png') : company.photos[0]", height=140)
          v-card-title(class="company-card__title") {{ company.name }}
          v-card-subtitle(class="company-card__subtitle") {{ company.numberOfComplexes }} комплексов
</template>

<script>
import Title from '../../components/Adverts/AddNew/Title'
export default {
  components: { Title },
  mounted() {
    this.$store.dispatch('GET_COMPANY_LIST')
  },
  computed: {
    companyList() {
      return this.$store.state.company.companyList
    }
  },
  methods: {
    viewCompanyPage(id) {
      this.$router.push({ path: `/company/list/${id}` })
    }
  }
}
</script>
<style lang="scss" scoped>
.company-card {
  border-radius: 6px !important;
  .v-image {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  &__title {
    color: #000;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.73 px;
  }
  &__subtitle {
    color: #8e8e93;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: -0.49 px;
  }
}
</style>
